import { useEffect, useState } from 'react'

export const useCountDown = (
  countFrom: number = 60,
  interval: number = 1000
) => {
  const [count, setCount] = useState(null)

  useEffect(() => {
    if (count === null) return
    if (count <= 0) {
      return setCount(null)
    }

    const t = setTimeout(() => {
      setCount(count - interval / 1000)
    }, interval)

    return () => {
      clearTimeout(t)
    }
  }, [count])

  return {
    startCountDown: (start?: number) => setCount(start ?? countFrom),
    stopCountDown: () => setCount(null),
    count,
  }
}
